import { Header } from '@/components/Header';
import { ManageUsers } from '@/pages/ManageUsers';
import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/_admin/admin/manage-users'
)({
  component: ManageUsersPage,
});

function ManageUsersPage() {
  const router = useRouterState();
  const childRouteIds = new Set([
    '/_authenticated/_admin/admin/manage-users/import',
  ]);
  const isChildRoute = router.matches.some((match) =>
    childRouteIds.has(match.routeId)
  );

  // Render child routes (import, etc.)
  if (isChildRoute) {
    return <Outlet />;
  }

  return (
    <>
      <Header enableBack additionalClasses="bg-slate-700" />
      <ManageUsers />
    </>
  );
}

